import React from "react";
import { motion, useInView } from "framer-motion";
import "./Eurogarant.css";
import EurogarantLogo from "../../assets/img/LogoEurogarant.png";
import EurogarantEmob from "../../assets/img/eurogarant-emob.png";

const LUXURY = [0.16, 1, 0.3, 1];

const specs = [
  "Kwaliteitsgarantie",
  "Europese normen",
  "Originele onderdelen",
  "Gespecialiseerd in hybride/elektrische voertuigen",
];

export default function Eurogarant() {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="eurogarant" className="eurogarant-section" ref={ref}>
      <div className="eurogarant-container">
        <div className="eurogarant-grid">

          {/* LEFT — Editorial text column */}
          <div className="eurogarant-text">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, ease: LUXURY }}
            >
              <span className="section-badge">Eurogarant</span>
              <h2 className="eurogarant-title">
                Niet zomaar een label.<br />Elk voertuig, elke keer goed.
              </h2>
              <p className="eurogarant-description">
                Het Eurogarant kwaliteitslabel is geen marketingterm — het is een
                belofte die we elke dag waarmaken. Strenge normen, originele
                onderdelen en gekalibreerde technieken, ook voor elektrische en
                hybride wagens.
              </p>
            </motion.div>

            <ul className="eurogarant-specs">
              {specs.map((spec, i) => (
                <motion.li
                  key={spec}
                  className="spec-item"
                  initial={{ opacity: 0, x: -12 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.6, ease: LUXURY, delay: 0.35 + i * 0.1 }}
                >
                  <span className="spec-bullet" aria-hidden="true" />
                  <span className="spec-label">{spec}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* HAIRLINE DIVIDER */}
          <div className="eurogarant-divider" aria-hidden="true" />

          {/* RIGHT — Certificate column: two framed certs side by side */}
          <motion.div
            className="eurogarant-cert"
            initial={{ opacity: 0, x: 40, clipPath: "inset(0 100% 0 0)" }}
            animate={inView ? { opacity: 1, x: 0, clipPath: "inset(0 0% 0 0)" } : {}}
            transition={{ duration: 0.9, ease: LUXURY, delay: 0.2 }}
          >
            <div className="cert-frame">
              <img
                src={EurogarantLogo}
                alt="Eurogarant Kwaliteitslabel"
                className="cert-image"
              />
            </div>
            <div className="cert-frame">
              <img
                src={EurogarantEmob}
                alt="Eurogarant E-Mobility Kwaliteitslabel"
                className="cert-image"
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
